import { Link } from 'react-router-dom';

import { List } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ShowContestEntity({ info, asLabel }) {
  const { row } = getInfo(info)

  const target = asLabel ? <span>Show contests</span> : <DefaultTooltip content='Show contests'><List size={16} /></DefaultTooltip>

  return <>
    <Link to={{ state: { sweepId: row.id }, pathname: `/cms/sweep/contests` }}>
      {target}
    </Link>
  </>
}
